import React, { useState } from "react";
import "./WhatsAppButton.css";

const WHATSAPP_NUMBER = "919781706262";
const WHATSAPP_MESSAGE = encodeURIComponent(
  "Hello! I am interested in learning more about Lyallpur Khalsa College Technical Campus & Courses.",
);

const WhatsAppButton = () => {
  const [hovered, setHovered] = useState(false);

  const handleClick = () => {
    window.open(
      `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  return (
    <div className="whatsapp-float-wrapper">
      {hovered && (
        <div className="whatsapp-tooltip">Chat with us on WhatsApp!</div>
      )}
      <button
        className="whatsapp-float-btn"
        onClick={handleClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        aria-label="Chat with us on WhatsApp"
        title="Chat with us on WhatsApp"
      >
        {/* WhatsApp SVG Icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 48 48"
          width="32"
          height="32"
          fill="none"
        >
          <circle cx="24" cy="24" r="24" fill="#25D366" />
          <path
            d="M34.6 13.4A14.9 14.9 0 0 0 24 9C16.28 9 10 15.28 10 23a14.9 14.9 0 0 0 2 7.5L9 39l8.7-2.28A14.94 14.94 0 0 0 24 38c7.72 0 14-6.28 14-14 0-3.74-1.46-7.26-3.4-10.6zM24 35.5a12.4 12.4 0 0 1-6.32-1.73l-.45-.27-4.67 1.22 1.25-4.55-.3-.47A12.38 12.38 0 0 1 11.5 23c0-6.9 5.6-12.5 12.5-12.5 3.34 0 6.48 1.3 8.84 3.66A12.43 12.43 0 0 1 36.5 23c0 6.9-5.6 12.5-12.5 12.5zm6.86-9.37c-.38-.19-2.23-1.1-2.57-1.22-.35-.13-.6-.19-.85.19-.25.38-.97 1.22-1.19 1.47-.22.25-.44.28-.82.09-.38-.19-1.6-.59-3.05-1.88-1.13-1-1.89-2.23-2.11-2.6-.22-.38-.02-.58.17-.77.17-.17.38-.44.57-.66.19-.22.25-.38.38-.63.13-.25.06-.47-.03-.66-.09-.19-.85-2.04-1.16-2.8-.3-.73-.62-.63-.85-.64h-.72c-.25 0-.66.09-.1.09s-.97.37-1.47.85c-.5.47-1.94 1.9-1.94 4.62s1.98 5.36 2.26 5.73c.28.38 3.9 5.95 9.44 8.35 1.32.57 2.35.91 3.15 1.17 1.32.42 2.52.36 3.47.22 1.06-.16 3.26-1.33 3.72-2.62.46-1.29.46-2.4.32-2.62-.14-.22-.38-.32-.76-.5z"
            fill="#fff"
          />
        </svg>
      </button>
    </div>
  );
};

export default WhatsAppButton;
